export const formatAmount = value => {
  const isNegative = value < 0;
  const positive = Math.abs(value);
  const full = positive.toFixed(2);
  const commas = parseInt(full.split(".")[0]).toLocaleString();
  const final = commas + full.slice(full.length - 3);
  return `${isNegative ? "-" : ""}£${final}`;
}